/**
 * AI Platform
 * Chat API of the hosted agent server (`@convercus/agent-server`). Read a chat as a view: a snapshot from `GET /chats/{chatId}/view`, then its changes from the NDJSON stream `GET /chats/{chatId}/view/stream?after` or the long-poll `GET /chats/{chatId}/view?after&waitMs`. The service sits behind the API gateway, which validates the JWT and forwards identity as plain headers — `program`, `user-id`, `username` and the user\'s `roles`. The view stream is the exception: it is reached without the gateway and verifies the `Authorization: Bearer` token itself. With `AUTH_MODE=mock` (local dev) every request runs as a canned identity and the headers are ignored. Every route but health names the permission it needs and answers 403 to a role that grants none of them: `agent.bi` (ANALYTICS, SUPER_ADMIN) for agents and chats; `agent.config.read`/`agent.config.write` (PROGRAM_MANAGER, SUPER_ADMIN) for the settings; dedicated mode and the spend ledger are SUPER_ADMIN only.
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface SetChatModeRequest { 
    /**
     * The chat\'s access mode: who answers when the agent needs a yes. \"ask\" surfaces every approval in the thread; \"accept-all\" auto-approves and logs it; \"view\" restricts turns to read-risk tools. Sticky per chat, changeable any time (never locked).
     */
    mode: SetChatModeRequest.ModeEnum;
}
export namespace SetChatModeRequest {
    export type ModeEnum = 'accept-all' | 'ask' | 'view';
    export const ModeEnum = {
        AcceptAll: 'accept-all' as ModeEnum,
        Ask: 'ask' as ModeEnum,
        View: 'view' as ModeEnum
    };
}


